import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { formatErr } from "@/lib/api";
import { SECTIONS } from "@/lib/sectionConfigs";
import { Button } from "@/components/ui/button";

const destinations = {
  ...Object.fromEntries(Object.entries(SECTIONS).map(([path, config]) => [config.key, { path, title: config.title }])),
  profile: { path: "general", title: "المعلومات العامة" },
  student_record: { path: "student-records", title: "سجلات الطلاب" },
  monthly_report: { path: "monthly-report", title: "التقرير الشهري" },
  plan_task: { path: "semester-plan", title: "الخطة الفصلية", semester: "legacy" },
  plan_task_1448_first: { path: "semester-plan", title: "خطة الفصل الأول", semester: "first" },
  plan_task_1448_second: { path: "semester-plan", title: "خطة الفصل الثاني", semester: "second" },
  guidance_committee_member: { path: "guidance-committee", title: "عضو لجنة التوجيه والإرشاد" },
  guidance_committee_meeting: { path: "guidance-committee", title: "محضر لجنة التوجيه والإرشاد" },
  student_council_roster: { path: "student-council", title: "أعضاء المجلس الطلابي" },
  student_council_meeting: { path: "student-council", title: "محضر المجلس الطلابي" },
  guidance_committee: { path: "guidance-committee", title: "لجنة التوجيه والإرشاد" },
  student_council: { path: "student-council", title: "المجلس الطلابي" },
  tardy: { path: "absence", title: "الغياب والتأخر" },
};

export default function PrincipalApprovalNotices() {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [refresh, setRefresh] = useState(0);
  const [updatedAt, setUpdatedAt] = useState("");
  useEffect(() => {
    let active = true;
    setLoading(true);
    setError("");
    api.get("/principal/pending-approvals").then(({ data }) => {
      if (active) {
        setEntries(data);
        setUpdatedAt(new Date().toISOString());
      }
    }).catch((failure) => { if (active) setError(formatErr(failure)); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [refresh]);
  return (
    <section className="no-print space-y-3 rounded-2xl border border-amber-300 bg-amber-50 p-5" aria-label="ملفات تنتظر اعتماد المدير">
      <div className="flex items-center justify-between gap-3">
        <h2 className="text-lg font-bold">تنبيه: ملفات تحتاج اطلاعك واعتمادك</h2>
        <Button type="button" variant="outline" disabled={loading} onClick={() => setRefresh((value) => value + 1)}>تحديث</Button>
      </div>
      {!loading && updatedAt && !error && <p className="text-xs text-[#4A554E]">آخر تحديث: {new Date(updatedAt).toLocaleString("ar-SA")}</p>}
      {loading ? <p>جاري تحديد الملفات التي تحتاج الاعتماد...</p> : error ? <p role="alert" className="text-red-700">{error}</p> : entries.length ? (
        <>
          <p>لديك {entries.length} قسم سجل يحتاج المراجعة. اعتماد القسم مرة واحدة لكل مرشد، ولا يتكرر عند إضافة أو تعديل إدخالاته.</p>
          <ul className="max-h-96 space-y-2 overflow-y-auto">
            {entries.map((entry) => {
              const destination = destinations[entry.source_type] || destinations[entry.type];
              const url = destination && `/supervisor/counselor/${encodeURIComponent(entry.counselor_id)}/${destination.path}${destination.semester ? `?semester=${destination.semester}` : ""}#approval-${encodeURIComponent(entry.id)}`;
              return <li key={`${entry.counselor_id}-${entry.type}`} className="rounded-xl border border-amber-200 bg-white p-3">
                <div className="font-semibold">{entry.counselor_name} — {destinations[entry.type]?.title || destination?.title || entry.type}</div>
                <div className="my-1 text-sm">لم يعتمد القسم بعد</div>
                {url ? <Link to={url} className="text-sm font-semibold text-[#27624d] underline">فتح الملف للمراجعة والاعتماد</Link> : <p role="alert" className="text-sm text-red-700">نوع السجل غير مرتبط بصفحة عرض؛ لا يمكن فتحه من التنبيه.</p>}
              </li>;
            })}
          </ul>
        </>
      ) : <p>لا توجد ملفات محفوظة تنتظر اعتمادك حاليًا.</p>}
    </section>
  );
}
